// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"478":"911e814d","940":"0fecfbf7"}[chunkId] || chunkId) + "." + {"459":"0e7077fc7fe1c355","478":"9c1e0876e0ba42d5","940":"5375b5c2f4551847","964":"72bf575e48d4b043"}[chunkId] + ".js";
};